export const appendInLookup = (context, lookup = {}): void => {
    if (!context) return

    const auxLookups = context?.params?.filter ? { ...JSON.parse(context.params.filter) } : {}

    Object.keys(lookup).forEach(key => {
        auxLookups[key] = lookup[key]
    })

    context.actions.setFilterValues(auxLookups)
}

export const getLookupFilterValues = (context, lookup?: string): unknown[] => {
    const values = context?.params?.filter ? JSON.parse(context.params.filter) : {}

    if (!lookup) return []

    return values[lookup] || []
}
